import React, { useState, useEffect } from 'react'
import './Right.css'
import TextArea from './TextArea'
import MetamaskContainer from './MetamaskContainer'
import zoombiesHead from '../assets/zoombies_head.png'
import ZoombiesVIP from '../abis/ZoombiesVIP.json'
import { ethers } from 'ethers';
import RightTopContainer from './RightTopContainer';
import FadeIn from 'react-fade-in'

const Right = (props) => {

    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner(props.account);
    const vip = new ethers.Contract(props.curr_address, ZoombiesVIP.abi, signer);
    
    const [vipStatus, setVipStatus] = useState(0);
    const [correctChain, setCorrectChain] = useState(false);
    const [pending, setPending] = useState(false);

    useEffect(() => {
        const get_status = async () => {
            if(props.account) {
                let vip_status = await vip.getVipStatus(props.account);
                setVipStatus(vip_status);
            }
            else {
                setVipStatus(0);
            }
            // setVipStatus(2);
        }
        get_status();
    }, [vip])

    useEffect(() => {
        if(window.ethereum.networkVersion == '1287' || window.ethereum.networkVersion == '1284') {
            setCorrectChain(true);
            props.setDisplayBanner(false);
        }
        else {
            setCorrectChain(false);
            props.setDisplayBanner(true);
            props.activateBrowserWallet();
        }
    }, [window.ethereum.networkVersion, props.account])

    return (
        <div className="right-container">
            <div className="zoombies-container">    
                <img className="zoombies-img" src={zoombiesHead} alt="Zoombie.world head"/>
                <FadeIn className="zoombies-text">ZOOMBIES.world</FadeIn>
            </div>
            <div className="right-top-container">
                <RightTopContainer correctChain={correctChain} vipStatus={vipStatus} pending={pending} account={props.account} chainId={props.chainId} deactivate={props.deactivate} setVipStatus={setVipStatus}></RightTopContainer>
            </div>
            <TextArea vipStatus={vipStatus} vip={vip} account={props.account} displayAdmin={props.displayAdmin} correctChain={correctChain} provider={provider} setPending={setPending} pending={pending} chainId={props.chainId}></TextArea>
            <div className="right-lower-container">
                <MetamaskContainer activateBrowserWallet={props.activateBrowserWallet} account={props.account} correctChain={correctChain}></MetamaskContainer>
                <div className="notice-text">
                    <span>*While supplies last.</span> 
                    <span>The VIP status NFT is a token that is soulbound to a wallet for its life. It’s purpose is for VIP status recognition in current and future systems. It is not intended to be traded or re-sold.</span>
                    <br/>
                    <span>
                        <a href='https://zoombies.info'>Zoombies NFT World website</a> |&nbsp; 
                        <a href='https://www.zoombies.info/privacy-policy'>Privacy Policy</a> |&nbsp;
                        <a href='https://www.zoombies.info/terms-and-conditions'>Terms & Conditions</a>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Right